import React from 'react'
import { Layout } from './components/styles'
import UserInfo from './components/userInfo'
import Collections from './components/Collections'
import FavoritesCarousel from './components/Favorites'
import HR from 'components/HR'

const Component = (): React.ReactElement<React.ComponentProps<any>, any> => {
  return (
    <Layout>
      <UserInfo />
      <div data-section='fav-col-section'>
        <FavoritesCarousel />
        <HR style={{margin: '24px 0px'}} />
        <Collections />
      </div>
    </Layout>
  )
}

export default Component